<script lang="ts" setup>
import type { IProps } from './UiCardBox.types'

defineProps<IProps>()
</script>

<template>
  <article class="box">
    <div class="box__image">
      <img :src="box.image.url">
    </div>

    <div
      class="box__content"
      :title="`${index+1}`"
    >
      <h3 class="box__title">
        {{ box.title }}
      </h3>

      <p class="box__text">
        {{ box.text }}
      </p>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.box {
  width: 100%;
  overflow: hidden;
  background-color: $white;
  border-radius: 1.6rem;

  &__image {
    width: 100%;
    height: 14.3rem;
    overflow: hidden;
    border-radius: 1.6rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    @include atM {
      height: 20rem;
    }
  }

  &__content {
    position: relative;
    padding-left: 6.4rem;
    font-weight: 500;

    &:before {
      position: absolute;
      top: -1.2rem;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 4.8rem;
      height: 4.8rem;
      color: $text-400;
      font-size: 1.8rem;
      line-height: 3.2rem;
      background-color: $gray-100;
      border-radius: 5rem;
      content: attr(title);
    }

    @include atM {
      &:before {
        top: -0.4rem;
      }
    }
  }

  &__title {
    margin-top: 2.2rem;
    margin-bottom: 0.8rem;
    font-size: 2rem;
    line-height: 2.8rem;

    @include atM {
      margin-top: 2.8rem;
      margin-bottom: 2.4rem;
      font-size: 2.8rem;
      line-height: 3.4rem;
    }

    @include atXL {
      font-size: 3.2rem;
      line-height: 4rem;
    }
  }

  &__text {
    font-size: 1.6rem;
    line-height: 2.4rem;

    @include atM {
      font-size: 1.8rem;
    }
  }
}
</style>
